import axios from '@/axios'


function getParents(keys) {
  let parents = []
  while (keys.length > 1) {
    keys.pop()
    parents.push(keys.join('.'))
  }
  return parents
}

const state = {
  loading: false,
  access_id:undefined,
  permissions:undefined
};

const actions = {
  setPermissions({commit}, payload){
    let rid = payload
    payload.map(x => {
      const keys = x.split('.')
      if (keys.length > 1) {
        const set1 = new Set([...rid, ...getParents(keys)])
        rid = [...set1]
      }
    })
    commit('SetPermissions', rid);
  },
  async save({commit}, payload) {
    try {
      commit('LOADING', true);
      await axios.post('admin/permission',{data: payload});
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING', false);
    }
  },
  async getOneId({commit}, payload) {
    try {
      commit('LOADING', true);
      const {data} = await axios.get(`admin/permission/${payload}`)
      commit('ACCESS_ID', data);
    } catch (e) {
      throw e;
    } finally {
      commit('LOADING', false);
    }
  }

}

const mutations = {
  SetPermissions(state, payload) {
    state.permissions = payload;
  },
  LOADING(state, payload) {
    state.loading = payload;
  },
  ACCESS_ID(state, payload) {
    state.access_id = payload;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
